export default {
  kdf: 'scrypt',
  n: 131072
};
